import React, { useRef, useState } from "react";
import {
  TrashIcon,
  EllipsisHorizontalCircleIcon,
} from "@heroicons/react/24/solid";
import { getCurrencyAndLanguageSymbol } from "../../../../constent/currencyUtils";
import Whatsapp from "../../../../assets/Icons/icons8-whatsapp (1).svg";

const DetailsCartRow = ({ details, onDelete, onEdit, onDetails }) => {
  const timeLeft = new Date(details.timeLeft);
  const now = new Date();
  const diff = timeLeft - now;

  let remainingTime = "Time Finish";
  if (diff > 0) {
    const seconds = Math.floor((diff / 1000) % 60);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);

    remainingTime = ` ${hours}: ${minutes}: ${seconds}`;
  }
  const roundToTwo = (num) => parseFloat(Number(num).toFixed(2));
  const currencySymbol = getCurrencyAndLanguageSymbol();

  const [showValue, setShowValue] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  const toggleValue = () => {
    setShowValue((prev) => !prev);
  };

  const values = [
    details.number,
    details.boxNumber,
    details.Name,
    details.phone,
    details.status,
    // details.note,
    details.history ? new Date(details.history).toISOString().slice(5, 10) : "",
    roundToTwo(Number(details.DShippingFees)),
    roundToTwo(Number(details.totalCartPriceBeforeFees)),
    roundToTwo(Number(details.markaShipFees)),
    roundToTwo(Number(details.totalCartPrice)),
    remainingTime, 
  ];

  return (
    <tr className="text-sm text-center text-gray-800 bg-white">
      {values.map((value, index) => (
        <td key={index} className="px-2 py-2">
          {index === 3 ? (
            <span className="flex items-center justify-center gap-4 text-black test-sm">
              {details.countryCode + value}
              <a href={`tel:${details.countryCode + value}`}>
                <img src={Whatsapp} className="w-5 " />
              </a>
            </span>
          ) : index === 100 ? (
            <>
              <div className="relative inline-block ">
                <span
                  onClick={toggleValue}
                  ref={buttonRef}
                  className="flex px-2 py-2 text-xs text-black cursor-pointer bg-custom-yellow"
                >
                  Show Info
                </span>

                {showValue && value && (
                  <div
                    className="absolute z-50 w-[500px] px-2 py-1 mt-2 text-sm bg-white border rounded shadow text-black"
                    ref={dropdownRef}
                  >
                    {value}
                  </div>
                )}
              </div>
            </>
          ) : index === 5 && details.history ? (
            <div className="flex flex-col">
              <span className="text-black">
                {new Date(details.history).toISOString().slice(5, 10)}
              </span>
              <span className="text-black">
                {new Date(details.history).toLocaleTimeString("en-US", {
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                  timeZone: "Asia/Kuwait",
                })}
              </span>
            </div>
          ) : index === 6 || index === 7 || index === 8 || index === 9 ? (
            <>
              <span className="text-black">
                {value}{" "}
                <span className="text-[9px] text-black"> {currencySymbol}</span>
              </span>
            </>
          ) : (
            value
          )}
        </td>
      ))}
      <td className="px-2 py-2">
        <div className="flex justify-around space-x-2">
          <button onClick={onDelete}>
            <TrashIcon className="w-5 h-5 text-red-600" />
          </button>
          {/* <button onClick={onEdit}>
            <PencilSquareIcon className="w-5 h-5 text-black" />
          </button> */}
        </div>
      </td>
      <td className="px-2 py-2">
        <div className="flex justify-around space-x-2">
          <button onClick={onDetails}>
            <EllipsisHorizontalCircleIcon className="bg-black rounded-full text-custom-yellow w-7" />
          </button>
        </div>
      </td>
    </tr>
  );
};

export default DetailsCartRow;
